import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { apiService, UserStatsAPI } from '../../api/api.service';

interface StatisticsState {
    users: UserStatsAPI[];
    isLoading: boolean;
    error: string | null;
    page: number;
    rowsPerPage: number;
    searchEmail: string;
    statusFilter: string;
}

const initialState: StatisticsState = {
    users: [],
    isLoading: false,
    error: null,
    page: 0,
    rowsPerPage: 10,
    searchEmail: '',
    statusFilter: 'all'
};

export const fetchStatistics = createAsyncThunk(
    'statistics/fetchAll',
    async (_, { rejectWithValue }) => {
        try {
            const data = await apiService.getUsersStatistics();
            return data;
        } catch (error) {
            return rejectWithValue('Failed to fetch statistics');
        }
    }
);

const statisticsSlice = createSlice({
    name: 'statistics',
    initialState,
    reducers: {
        setPage: (state, action: PayloadAction<number>) => {
            state.page = action.payload;
        },
        setRowsPerPage: (state, action: PayloadAction<number>) => {
            state.rowsPerPage = action.payload;
            state.page = 0;
        },
        setSearchEmail: (state, action: PayloadAction<string>) => {
            state.searchEmail = action.payload;
            state.page = 0;
        },
        setStatusFilter: (state, action: PayloadAction<string>) => {
            state.statusFilter = action.payload;
            state.page = 0;
        },
        updateUser: (state, action: PayloadAction<UserStatsAPI>) => {
            const index = state.users.findIndex(user => user.id === action.payload.id);
            if (index !== -1) {
                state.users[index] = action.payload;
            }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchStatistics.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchStatistics.fulfilled, (state, action) => {
                state.users = action.payload;
                state.isLoading = false;
            })
            .addCase(fetchStatistics.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload as string;
            });
    }
});

export const { setPage, setRowsPerPage, setSearchEmail, setStatusFilter, updateUser } = statisticsSlice.actions;

export default statisticsSlice.reducer; 